import data from "../../shared/sharedData";

export default {
  name: "Attorney or Agent Information",
  prefix: "C",
  pageInfo: {
    text: `<b><u>Note:</u></b> The attorney/agent information in this section—specifically the name, telephone number, and email address—<u>must</u> be different from the employer’s point of contact information in Section B, except when an attorney listed in this Section is an employee of the employer.<br/><br/>Questions 17 through 19 in this section must be answered when “Attorney” is selected and instances in which an “Attorney” is acting as an “Agent” in response to question C.1.  The answers to questions 18 and 19 below should correspond to the same state for which a bar number was provided in question 17, if any. `,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Attorney/Agent profile to populate this section (optional)",
          code: "C",
          prefill: {
            schema: "agent-attorney-9089",
            type: "agent-attorney-individs",
            formName: "9089",
            formSection: "C",
          },
        },
        {
          isGroup: {
            code: "C.1",
            machine_name: "attyAgRepType",
            label: `Indicate the type of representation for the employer in the filing of this application. (Complete the remainder of this section if “Attorney” or “Agent” is marked) *`,
            tooltip:
              "Identify whether an attorney or agent is filing this application on behalf of the employer.  Only mark one box.  If “Attorney” or “Agent” is selected, complete the remainder of Section C.  If “None” is selected, skip questions 2 to 19 in this section and continue to Section D.",
            coloring: "none",
            clearBtn: {
              clearSchema: ["attyAgRepType"],
            },
            //required: true,
            fields: [
              {
                widget: "radio",
                choice: "Attorney",
                value: "Attorney",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Agent",
                value: "Agent",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "None",
                value: "None",
                validate: ["required"],
                clearSchema: [
                  "attyAgLastName",
                  "attyAgFirstName",
                  "attyAgMiddleName",
                  "attyAgAddress1",
                  "attyAgAddress2",
                  "attyAgCountry",
                  "attyAgCity",
                  "attyAgState",
                  "attyAgProvince",
                  "attyAgPostalCode",
                  "attyAgPhone",
                  "attyAgPhoneExt",
                  "attyAgEmail",
                  "attyAgLawFirmName",
                  "attyAgFEIN",
                  "attyAgStateBarNumber",
                  "attyAgGoodStandingState",
                  "attyAgGoodStandingAttorney",
                ],
              },
            ],
          },
        },
      ],
    },
    {
      isVisible: {
        when: "attyAgRepType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "C.2",
          machine_name: "attyAgLastName",
          widget: "text",
          label: "Attorney or Agent's Last (family) Name §",
          validate: [
            "required",
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message:
                "Attorney or Agent's Last Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the last (family) name of the attorney/agent.",
        },
        {
          code: "C.3",
          machine_name: "attyAgFirstName",
          widget: "text",
          label: "First (given) Name §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the first (given) name of the attorney/agent.",
        },
        {
          code: "C.4",
          machine_name: "attyAgMiddleName",
          widget: "text",
          label: "Middle Name(s) §",
          maxLength: 35,
          tooltip:
            "Enter the middle name(s) of the attorney/agent, if applicable.  If the attorney/agent does not have a middle name, enter “N/A.”",
        },
      ],
    },
    {
      isVisible: {
        when: "attyAgRepType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "C.5",
          machine_name: "attyAgAddress1",
          widget: "text",
          label: "Address 1 §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message: "Address 1 must contain at least 2 characters.",
            },
          ],
          maxLength: 60,
          tooltip: "Enter the business street address of the attorney/agent.",
        },
        {
          code: "C.6",
          machine_name: "attyAgAddress2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i> §</span>",
          maxLength: 60,
          tooltip:
            "If additional space is required for the street address, use this field to complete the attorney/agent’s street address.  If no additional space is required, enter “N/A.”",
        },
        {
          code: "C.10",
          machine_name: "attyAgCountry",
          widget: "select",
          label: "Country §",
          selection: data.country,
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
          ],
          clearSchema: ["attyAgState", "attyAgProvince"],
          tooltip: "Enter the country of the attorney/agent. ",
        },
        {
          code: "C.7",
          machine_name: "attyAgCity",
          widget: "text",
          label: "City §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          disabled: true,
          disableWhenField: "attyAgCountry",
          tooltip: "Enter the city of the attorney/agent.",
        },
        {
          code: "C.8",
          machine_name: "attyAgState",
          widget: "select",
          label: "State §",
          selection: data.state,
          required: true,
          disabled: true,
          disableWhenField: "attyAgCountry",
          state: true,
          maxLength: 35,
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
          ],
          isVisible: {
            when: "attyAgCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          tooltip:
            "Enter the state, district, or territory of the attorney/agent.",
        },
        {
          code: "C.11",
          machine_name: "attyAgProvince",
          widget: "text",
          label: "Province §",
          maxLength: 25,
          validate: [
            {
              isRequired: "attyAgCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          isVisible: {
            when: "attyAgCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
            hideStyles: true,
          },
          tooltip:
            "Enter the province of the attorney/agent, if applicable.  Enter “N/A” if not applicable.",
        },
        {
          code: "C.9",
          machine_name: "attyAgPostalCode",
          widget: "text",
          label: "Postal Code §",
          validate: [
            {
              isRequired: "attyAgCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
            {
              postalCountry: "attyAgCountry",
              needsFieldValues: true,
              extraData: {
                valueOf: "attyAgCountry",
              },
            },
          ],
          disabled: true,
          disableWhenField: "attyAgCountry",
          maxLength: 10,
          tooltip: "Enter the postal (zip) code of the attorney/agent.",
        },
      ],
    },
    {
      isVisible: {
        when: "attyAgRepType",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "C.12",
          machine_name: "attyAgPhone",
          widget: "phone",
          label: "Telephone Number §",
          validate: [
            "phone",
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
          ],
          tooltip:
            "Enter the area code and telephone number of the attorney/agent. Include country code, if outside of the United States.",
        },
        {
          code: "C.13",
          machine_name: "attyAgPhoneExt",
          widget: "text",
          label: "Extension §",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the attorney/agent, if applicable.  Enter “N/A” if not applicable.",
        },
        {
          code: "C.14",
          machine_name: "attyAgEmail",
          widget: "text",
          label: "Law Firm/Business Email Address §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 70,
          warning: {
            text: "The employer point of contact must be different from the agent/attorney, unless the agent/attorney is an employee of the employer.",
            isVisible: {
              when: "attyAgLastname attyAgFirstname attyAgMiddlename attyAgPhone attyAgEmail",
              is: [
                "empPocLastName",
                "empPocFirstName",
                "empPocMiddleName",
                "empPocPhone",
                "empPocEmail",
              ],
              operator: "conditionTwoSetsMatchAll",
            },
          },
          tooltip:
            "Enter the business email address of the attorney/agent in the format <u>name@emailaddress.top-level domain</u>.  The email entered in this field must be the one regularly used by the attorney/agent’s point of contact to send and receive electronic communications from the Department with respect to the processing of this application.  If the attorney/agent’s point of contact does not possess a business email address, please enter “N/A.”",
        },
        {
          code: "C.15",
          machine_name: "attyAgLawFirmName",
          widget: "text",
          label: "Law Firm/Business Name §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Agent",
              },
            },
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 5,
              message:
                "Law Firm/Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip:
            "Enter the attorney/agent’s law firm or business name.  The attorney/agent’s law firm or business name is the exact name that is reported to the IRS. ",
        },
        {
          code: "C.16",
          machine_name: "attyAgFEIN",
          widget: "text",
          label: "Law Firm/Business FEIN §",
          disableWhenField: {},
          validate: [
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
            {
              FEINPrefixValidator: "attyAgFEIN",
              needsFieldValues: true,
              message: "This is not a valid FEIN",
            },
            {
              isRequiredx2: [["attyAgRepType"], ["attyAgCountry"]],
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [["Attorney"], ["UNITED STATES OF AMERICA"]],
              },
            },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the attorney/agent's law firm or business nine-digit FEIN as assigned by the IRS. <b><u>Do not enter a social security number.</u></b>",
        },
        {
          code: "C.17",
          machine_name: "attyAgStateBarNumber",
          widget: "text",
          label: "State Bar Number(s) §",
          validate: [
            { minLength: 2 },
            {
              isRequiredx2: [["attyAgRepType"], ["attyAgCountry"]],
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [["Attorney"], ["UNITED STATES OF AMERICA"]],
              },
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the attorney’s state bar number.  If the attorney is licensed in more than one state, enter only one state bar number.  If submitting this form electronically and the attorney is licensed in a state that does not issue state bar numbers, leave the field blank and once confirmed the field will be automatically pre-populated with “N/A.”  If the employer is not filing electronically, please enter “N/A.”",
        },
        {
          code: "C.18",
          machine_name: "attyAgGoodStandingState",
          widget: "select",
          label:
            "State of highest state court where attorney is in good standing §",
          selection: data.state,
          disableWhenField: "attyAgCountry",
          state: true,
          maxLength: 35,
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message:
                "State Bar Number(s) must contain at least 2 characters.",
            },
          ],
          tooltip:
            "Enter the <u>state</u> of the highest court where the attorney is in good standing.",
        },
        {
          code: "C.19",
          machine_name: "attyAgGoodStandingAttorney",
          widget: "text",
          label:
            "Name of the highest state court where attorney is in good standing §",
          validate: [
            {
              isRequired: "attyAgRepType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "Attorney",
              },
            },
            {
              minLength: 2,
              message:
                "Name of the highest state court where attorney is in good standing must contain at least 2 characters.",
            },
          ],
          maxLength: 55,
          tooltip:
            "Enter the <u>name</u> of the highest court in the state where the attorney is in good standing.",
        },
      ],
    },
  ],
};
